import React from "react";

export default function CheckMark() {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 17 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.30011 10.9053L1.80011 7.40533C1.70858 7.31269 1.59958 7.23914 1.47942 7.18894C1.35926 7.13874 1.23033 7.11289 1.10011 7.11289C0.969881 7.11289 0.84095 7.13874 0.72079 7.18894C0.600629 7.23914 0.491628 7.31269 0.400105 7.40533C0.307466 7.49685 0.233914 7.60585 0.183715 7.72602C0.133515 7.84618 0.107666 7.97511 0.107666 8.10533C0.107666 8.23556 0.133515 8.36449 0.183715 8.48465C0.233914 8.60481 0.307466 8.71381 0.400105 8.80533L4.59011 12.9953C4.9801 13.3853 5.6101 13.3853 6.0001 12.9953L16.6001 2.40533C16.6927 2.31381 16.7663 2.20481 16.8165 2.08465C16.8667 1.96448 16.8925 1.83556 16.8925 1.70533C16.8925 1.5751 16.8667 1.44618 16.8165 1.32601C16.7663 1.20585 16.6927 1.09685 16.6001 1.00533C16.5086 0.91269 16.3996 0.839139 16.2794 0.788939C16.1593 0.738739 16.0303 0.712891 15.9001 0.712891C15.7699 0.712891 15.6409 0.738739 15.5208 0.788939C15.4006 0.839139 15.2916 0.91269 15.2001 1.00533L5.30011 10.9053Z"
        fill="red"
      />
    </svg>
  );
}
